import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import { getRoles, useAuth } from "@ssf/auth-components";
import { DotsVertical } from "mdi-material-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router";

import { generatePath } from "../lib/index.js";
import { TeamLeaderSearch } from "./TeamLeaderSearch.js";

export const HeaderMenu = () => {
  const { t } = useTranslation("HeaderMenu");
  const { user, isFedAdmin } = useAuth();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  const [isRegistrationOpen, setRegistrationOpen] = useState(false);
  const navigate = useNavigate();
  const isSchoolAdmin =
    isFedAdmin || getRoles(user).some((role) => role.startsWith("district:"));

  if (!isSchoolAdmin) {
    return null;
  }

  return (
    <>
      <IconButton onClick={({ currentTarget }) => setAnchorEl(currentTarget)}>
        <DotsVertical />
      </IconButton>
      <Menu
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(undefined)}
      >
        {isFedAdmin && (
          <MenuItem
            onClick={() => {
              setAnchorEl(undefined);
              setRegistrationOpen(true);
            }}
          >
            {t("registerTeam")}
          </MenuItem>
        )}
        <MenuItem
          component={Link}
          to={generatePath("schoolStats", {})}
          onClick={() => setAnchorEl(undefined)}
        >
          {t("schools")}
        </MenuItem>
      </Menu>
      {isFedAdmin && isRegistrationOpen && (
        <Dialog
          open
          fullWidth
          maxWidth="sm"
          onClose={() => setRegistrationOpen(false)}
          onKeyDown={(event) => {
            if (
              event.key.toLowerCase() === "k" &&
              (event.metaKey || event.ctrlKey)
            ) {
              // Keep both global search shortcuts from toggling behind this dialog.
              event.preventDefault();
              event.stopPropagation();
            }
          }}
        >
          <DialogTitle>{t("registerTeam")}</DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              {t("registerTeamDescription")}
            </DialogContentText>
            <TeamLeaderSearch
              onSelect={(memberId) => {
                setRegistrationOpen(false);
                navigate(generatePath("regTeam", { memberId }));
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setRegistrationOpen(false)}>
              {t("cancel")}
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};
